import type { IconName } from "@nexus/ui";

/** Coarse media classification derived from an asset's MIME type. */
export type MediaKind = "video" | "image" | "other";

export function mediaKind(contentType: string | null | undefined): MediaKind {
  if (contentType?.startsWith("video/")) return "video";
  if (contentType?.startsWith("image/")) return "image";
  return "other";
}

const MEDIA_KIND_ICON: Record<MediaKind, IconName> = {
  video: "clapperboard",
  image: "image",
  other: "file",
};

export function mediaKindIcon(kind: MediaKind): IconName {
  return MEDIA_KIND_ICON[kind];
}

/** i18n key for the human label of a media kind (e.g. `preflight.media.video`). */
export function mediaKindLabelKey(kind: MediaKind): string {
  return `preflight.media.${kind}`;
}
